//* Para utilizar a captura manual dos campos, descomentar as linhas comentadas
//* e desativar a captura automatica no RD Station
// import config from "../config/config"; // Config com o token do RD
import { nameValidateProps, phoneValidateProps } from "../services/ValidateService";

const form = $('.leads-form, .rich-content-form');

//* Passando os campos
// const leadsData = {
//   identificador: form.attr('name'),
//   nome: form.find('[name="nome"]'),
//   email: form.find('[name="email"]'),
//   telefone: form.find('[name="telefone"]'),
//   cargo: form.find('[name="cargo"]'),
//   escola: form.find('[name="escola-nome"]'),
//   escolaPerfil: form.find('[name="escola-perfil"]'),
//   ensinoTipos: $('input[name="ensino-tipos"]:checked').toArray().map(etapa => $(etapa).val()),
//   alunosQtd: form.find('[name="alunos-qtd"]'),
//   bilingue: form.find('[name="escola-bilingue"]'),
//   local: form.find('[name="escola-local'),
//   aceitaNews: form.find('[name="newsletter"]').is(':checked') ? 'Sim' : 'Não',
//   pageUrl: form.find('[name="page-url"]'),
//   pageTitle: form.find('[name="page-title"]'),
// };

export const FormLeadsOptions = {
  form,
  modalMessage: true,
  rules: {
    ...nameValidateProps.rules,
    ...phoneValidateProps.rules,
    'ensino-tipos': 'required'
  },
  messages: {
    ...nameValidateProps.messages,
    ...phoneValidateProps.messages,
  },
  customSubmitHandler: function () {
    const pgThankYou = form.data('redirect');
    window.location.href = pgThankYou;
  },
  //* Atribuindo os campos do form aos que aparecem nos detalhes do lead no RD
  // dataToRdStation: [
  //   // `name` aqui e o que vai aparecer la nos detalhes do lead
  //   { name: 'identificador', value: leadsData.identificador },
  //   { name: 'Nome', value: leadsData.nome.val() },
  //   { name: 'email', value: leadsData.email.val() },
  //   { name: 'Telefone', value: leadsData.telefone.val() },
  //   { name: 'Cargo', value: leadsData.cargo.val() },
  //   { name: 'Nome da escola', value: leadsData.escola.val() },
  //   { name: 'Perfil da escola', value: leadsData.escolaPerfil.val() },
  //   { name: 'Quantidade de alunos', value: leadsData.alunosQtd.val() },
  //   { name: 'Possui ensino bilíngue?', value: leadsData.bilingue.val() },
  //   { name: 'Local da escola', value: leadsData.local.val() },
  //   { name: 'Tipos de ensino', value: leadsData.ensinoTipos.join(', ') },
  //   { name: 'Aceita receber comunicação', value: leadsData.aceitaNews },
  //   { name: 'URL da página', value: leadsData.pageUrl.val() },
  //   { name: 'Título da página', value: leadsData.pageTitle.val() },
  //   { name: 'token_rdstation', value: config.RDStation.token_rdstation }
  // ],
}